import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={33} height={42} fill="none" {...props}>
        <Path
            fill={designSystem.colors.neutral900}
            stroke={designSystem.colors.neutral400}
            d="M15.742.5c4.869 0 8.882 1.65 11.676 4.598 2.791 2.945 4.322 7.14 4.322 12.156 0 8.984-5.716 19.254-14.793 24.04l-.11.058H3.7l-.215-.952c6.411-3.039 12.268-7.618 15.425-12.394-1.502.79-3.255 1.25-5.166 1.25C6.827 29.256.5 23.526.5 15.472.5 7.606 6.208.5 15.742.5Zm.485 8.938c-1.553 0-2.92.55-3.899 1.522-.976.97-1.594 2.39-1.594 4.188 0 1.827.62 3.26 1.595 4.237.978.977 2.345 1.527 3.898 1.527 1.583 0 2.95-.55 3.92-1.526.968-.975 1.575-2.408 1.575-4.238 0-1.8-.606-3.22-1.575-4.189-.97-.97-2.337-1.52-3.92-1.52Z"
        />
    </Svg>
);
export { SvgComponent as NineIcon };
